import {fromEvent, timer} from 'rxjs';
import {HintService} from './hint.service';
import {Injectable} from '@angular/core';
import {LsService} from './ls.service';
import {Platform} from '@angular/cdk/platform';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PwaInstallService {

  private readonly LS_ALREADY_PROMPTED = 'installPrompted';

  private promptEvent: any;

  constructor(
    private hintService: HintService,
    private lsService: LsService,
    private platform: Platform,
  ) {
  }

  initPwaPrompt() {
    if (!this.platform.IOS) {
      fromEvent(window, 'beforeinstallprompt')
        .subscribe(
          (e) => {
            e.preventDefault();
            this.promptEvent = e;
            this.openHint('android');
          }
        );
    } else {
      const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
      if (!isInStandaloneMode) {
        this.openHint('ios');
      }
    }
  }

  private openHint(mobileType: 'ios' | 'android') {
    if (this.lsService.getItem(this.LS_ALREADY_PROMPTED) === 'true') {
      return;
    }
    timer(3000)
      .pipe(take(1))
      .subscribe(() => {
        this.hintService.newHint('pwa-install');
      });
  }

  doInstall(): void {
    this.hintService.newHint('');
    this.promptEvent.prompt();
  }

  ignoreInstall(): void {
    this.hintService.newHint('');
    this.lsService.setItem(this.LS_ALREADY_PROMPTED, true);
  }

}
